import React from "react";
import {REVIEW_STATUS} from "../constants";

/** Where a listing/project is: its review state, or "Live"/"Hidden" once approved, plus "Edits in review". */
const StatusBadge = ({status, active, pendingChanges}) => {
    let label = REVIEW_STATUS[status]?.label || status;
    let tone = REVIEW_STATUS[status]?.tone || "grey";
    if (status === "APPROVED" && active !== undefined) {
        label = active ? "Live" : "Hidden";
        tone = active ? "green" : "grey";
    }
    return (
        <span className="brk-badges">
            <span className={`brk-badge brk-badge--${tone}`}>{label}</span>
            {pendingChanges && <span className="brk-badge brk-badge--amber">Edits in review</span>}
        </span>
    );
};

export default StatusBadge;
